import React from 'react';

import CodeIcon from '@mui/icons-material/Code';
import VerticalSplitIcon from '@mui/icons-material/VerticalSplit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Tooltip from '@mui/material/Tooltip';

/** md / knz エディタの表示モード */
export type EditorViewMode = 'edit' | 'split' | 'preview';

type Props = {
  value: EditorViewMode;
  onChange: (mode: EditorViewMode) => void;
};

/**
 * エディタ / 分割 / プレビュー を切り替えるセグメントトグル。
 * md・knz 共通で使う。
 */
export const ViewModeToggle: React.FC<Props> = ({ value, onChange }) => {
  return (
    <ToggleButtonGroup
      size="small"
      exclusive
      value={value}
      onChange={(_, next) => {
        if (next) onChange(next as EditorViewMode);
      }}
      sx={{
        '& .MuiToggleButton-root': {
          px: 1,
          py: 0.25,
          border: 1,
          borderColor: 'divider',
          textTransform: 'none',
        },
      }}
    >
      <ToggleButton value="edit">
        <Tooltip title="エディタ（Cmd/Ctrl+P で切替）">
          <CodeIcon fontSize="small" />
        </Tooltip>
      </ToggleButton>
      <ToggleButton value="split">
        <Tooltip title="分割（Cmd/Ctrl+\\）">
          <VerticalSplitIcon fontSize="small" />
        </Tooltip>
      </ToggleButton>
      <ToggleButton value="preview">
        <Tooltip title="プレビュー（Cmd/Ctrl+P で切替）">
          <VisibilityIcon fontSize="small" />
        </Tooltip>
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default ViewModeToggle;
